<template>
  <div class="commission-types">
    <!-- 新增的对话框 -->
    <el-dialog
      center
      width="1400px"
      title="修改楼盘佣金"
      :visible.sync="dialogTableVisible"
      @opened="getLoad"
      @close="handleClose()"
    >
      <h4 style="padding: 20px 0">当前楼盘：{{ houseName }}</h4>
      <el-form ref="form" :model="form">
        <el-row>
          <el-col :span="6">
            <el-form-item
              label="复核状态"
              :label-width="formLabelWidth"
              prop="reviewStatus"
            >
              <el-select
                class="search-select"
                v-model="form.reviewStatus"
                clearable
                placeholder="请选择复核状态"
              >
                <el-option
                  v-for="item in checkStatusList"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item class="btn">
              <el-button @click="onSearch" icon="el-icon-search" size="small"
                >查询</el-button
              >
              <el-button
                style="margin: 0 20px"
                size="small"
                icon="el-icon-delete"
                @click="resetForm('form')"
                >清空</el-button
              >
              <!-- <el-button
              class="search-tabs_button"
              size="small"
              @click="onRefresh"
              icon="el-icon-refresh"
              >刷新</el-button
            > -->
              <el-button type="primary" size="small" @click="handleAdd"
                >增加</el-button
              >
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column
          prop="validityCalculateType"
          label="结算方式"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.validityCalculateType == 1
                ? '固定金额佣金'
                : '楼盘总价*点数'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="230">
          <template slot-scope="scope">
            <div>开始时间：{{ scope.row.validityStartTime }}</div>
            <div>结束时间：{{ scope.row.validityEndTime }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="validityFixedBonus" label="售佣金金额/比例">
          <template slot-scope="scope">
            <span>{{
              scope.row.validityCalculateType == 1
                ? scope.row.validityFixedBonus
                : scope.row.validityBonusPoint
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rentBasePoint" label="租佣金金额/基数">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间"> </el-table-column>
        <el-table-column prop="updateTime" label="更新时间"> </el-table-column>
        <el-table-column label="复核状态">
          <template slot-scope="scope">
            <!--  0：未复核 1：已复核，2：驳回 -->
            <span>{{ checkStatus[scope.row.reviewStatus].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewMan" label="复核人">
          <template slot-scope="scope">
            <span>{{ handledecrypt(scope.row.reviewMan) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewTime" label="复核时间"> </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button
              v-if="roleList[path].includes('_House_Dia_Rrcord')"
              size="mini"
              type="text"
              @click="handleCheck(scope.$index, scope.row)"
              >更新记录</el-button
            >
            <el-button
              v-if="roleList[path].includes('_House_Dia_Edit')"
              size="mini"
              type="text"
              style="margin: 0 10px"
              @click="handleEdit(scope.$index, scope.row)"
              >修改</el-button
            >
            <el-button
              v-if="
                roleList[path].includes('_House_Dia_Review') &&
                scope.row.reviewStatus == 0
              "
              size="mini"
              type="text"
              @click="handleReview(scope.$index, scope.row)"
              >复核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 更新记录 -->
    <updateRecord ref="updateRecord" />

    <!-- 增加/编辑 -->
    <editFromRate ref="editFromRate" @reload="getLoad" />

    <!-- 复核 -->
    <editeCheck ref="editeCheck" @reload="getLoad" />
  </div>
</template>
<script>
const updateRecord = () => import('./updateRecord'); // 更新记录
const editFromRate = () => import('./editFromRate'); // 编辑佣金
const editeCheck = () => import('./editeCheck'); // 复核
import { decrypt } from '@/utils/encryp';

import { mapGetters } from 'vuex';
import { getCommisionListApi } from '@/api/houseApi.js';
export default {
  components: {
    updateRecord,
    editFromRate,
    editeCheck,
  },
  data() {
    return {
      dialogTableVisible: false,
      listLoading: false,
      houseId: '',
      houseRateId: '',
      houseName: '',
      tableData: [],
      checkStatus: {
        0: {
          label: '未复核',
        },
        1: {
          label: '已复核',
        },
        2: {
          label: '驳回',
        },
      },
      formLabelWidth: '80px',
      checkStatusList: [
        {
          label: '未复核',
          id: 0,
        },
        {
          label: '已复核',
          id: 1,
        },
        {
          label: '驳回',
          id: 2,
        },
      ],
      form: {
        reviewStatus: '',
      },
    };
  },
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {},
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 关闭弹框
    handleClose() {
      this.resetForm('form');
    },
    // 初始化数据
    getLoad() {
      try {
        this.listLoading = true;
        getCommisionListApi({
          pageSize: 100,
          pageIndex: 1,
          houseId: this.houseId,
          reviewStatus: this.form.reviewStatus,
        }).then((res) => {
          this.tableData = res.data.dataList;
          this.listLoading = false;
          //   this.$refs.Pagination.pageSize = res.data.pageSize;
          //   this.$refs.Pagination.pageIndex = res.data.pageIndex;
          //   this.$refs.Pagination.totalCount = res.data.totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 列表样式
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    // 增加
    handleAdd() {
      this.$refs.editFromRate.title = '增加楼盘佣金';
      this.$refs.editFromRate.houseId = this.houseId;
      this.$refs.editFromRate.dialogFormVisible = true;
    },
    // 编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.$refs.editFromRate.title = '编辑楼盘佣金';
      this.$refs.editFromRate.houseId = this.houseId;
      this.$refs.editFromRate.houseRateId = row.houseRateId;
      this.$refs.editFromRate.dialogFormVisible = true;
    },
    // 查看记录
    handleCheck(index, row) {
      console.log(index, row);
      this.$refs.updateRecord.houseName = row.houseName;
      this.$refs.updateRecord.houseId = this.houseId;
      this.$refs.updateRecord.houseRateId = row.houseRateId;
      this.$refs.updateRecord.dialogTableVisible = true;
    },
    // 复核
    handleReview(index, { houseRateId }) {
      // console.log(index, row);
      this.$refs.editeCheck.title = '复核';
      // this.$refs.editeCheck.houseName = row.houseName;
      // this.$refs.editeCheck.houseId = this.houseId;
      this.$refs.editeCheck.editForm.houseRateId = houseRateId;
      // this.$refs.editeCheck.editForm.reviewStatus = reviewStatus;
      // this.$refs.editeCheck.editForm.reviewOpinion = reviewOpinion;
      this.$refs.editeCheck.dialogFormVisible = true;
    },

    // 查询
    onSearch() {
      this.getLoad();
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.form.reviewStatus = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
